import 'bootstrap/dist/css/bootstrap.min.css'; 
import { Controller, Control, UseFormRegister, UseFormSetValue } from 'react-hook-form'
import { CustomLabel } from './CustomLabel';
import { InputErrorMessage } from './InputErrorMessage';
import InputMask from 'react-text-mask'; 
import { formatMaskPhone } from 'shared/util/functions/mascaras/TelefoneMask';

type TelefoneInputWithoutValidationProps = {
    usarValidacaoParaFormulario: false
}

type TelefoneInputWithValidationProps = {
    id: string,
    usarValidacaoParaFormulario: true
    /**Nome do atributo que será usado no formulario para realizar as validacoes*/
    name: string,
    register : UseFormRegister<any>
    control: Control<any>,
    setValue: UseFormSetValue<any>
} 

type TelefoneInputProps = {
    id: string;
    label?: string;
    placeholder?: string;
    className? : string;
    type? : string;
    onChange?: (event : React.ChangeEvent<HTMLInputElement>) => void,
    defaultValue? : string
} & (TelefoneInputWithoutValidationProps | TelefoneInputWithValidationProps)

const TelefoneInput: React.FC<TelefoneInputProps> = (props) => {

    const getCustomStyle = (possuiErro: boolean) =>{
        return possuiErro ? {border: '1px solid #dc3545', transition: 'none'} : {}
    }

    const renderTelefoneInputComValidacao = () => {
        if(props.usarValidacaoParaFormulario){
            return (
                <Controller
                    name={props.name}
                    control={props.control}
                    defaultValue={props.defaultValue}
                    render={({ field, fieldState }) => (
                        <>
                        {props.label && <CustomLabel possuiErro={fieldState.error !=null}>{props.label}</CustomLabel>}
                        <InputMask 
                            {...field}
                            {...props.register(props.name)} 
                            id={props.name}
                            className="form-control input-gc" 
                            placeholder={props.placeholder}
                            mask={formatMaskPhone}
                            style={getCustomStyle(fieldState.error!=null)}
                            onChange={(event : React.ChangeEvent<HTMLInputElement>) => {
                                field.onChange(event)
                                props.setValue(props.name, event.target.value)
                                props.onChange && props.onChange(event)
                            }}
                            showMask={false}
                        />
                        {fieldState.error && <InputErrorMessage>{fieldState.error.message}</InputErrorMessage>}
                        </>
                    )}
                />
            )
        }
    }

    const renderTelefoneInputSemValidacao = () => {
        if(!props.usarValidacaoParaFormulario){
            return (
                <>
                    {props.label && <CustomLabel possuiErro={false}>{props.label}</CustomLabel>}
                    <InputMask 
                        id={props.id}
                        className="form-control input-gc" 
                        placeholder={props.placeholder}
                        mask={formatMaskPhone}
                        style={getCustomStyle(false)}
                        onChange={(event : React.ChangeEvent<HTMLInputElement>) => {
                            props.onChange && props.onChange(event)
                        }}
                        showMask={false}
                        defaultValue={props.defaultValue}
                    />
                </>
            )
        }
    }
    
    return (
    <div className={props.className || ''}>
        {props.usarValidacaoParaFormulario && renderTelefoneInputComValidacao()}
        {!props.usarValidacaoParaFormulario && renderTelefoneInputSemValidacao()}
    </div>
    );
};

export default TelefoneInput;